/* eslint-disable import/prefer-default-export */
export const optionsTools = (t) => [
    {
        aclCode: 'oms_lite_header_tools',
        key: 'tools',
        label: t('menu:Tools'),
        url: '/tools',
    },
];
